const undefinedOrNull = (value) => typeof value === 'undefined' || value === null;

export default undefinedOrNull;
